import g from '#core/global';
import load from '#core/load';


const container_$ = '.factsheet-search';
const select_$ = '.factsheet-search__select-container select';
const bound_attr = 'data-factsheet-search-bound';


const module = {
	/**
	 * Init module
	 */
	init() {
		if (load.ran('factsheet-search')) return false;

		load.content(() => {
			const $containers = document.querySelectorAll(container_$);
			$containers.forEach(setup);
		});
	},
};

export default module;
module.init();


/**
 * Bind change handler to the factsheet select; navigates to the selected
 * factsheet, or resets to the current page when the empty option is chosen.
 * @param {Element} $container
 */
function setup($container) {
	const $select = $container.querySelector(select_$);
	if (!$select || $select.getAttribute(bound_attr) === g.true_s) return false;

	$select.setAttribute(bound_attr, g.true_s);

	$select.addEventListener(g.change_e, () => {
		window.location.href = $select.value
			|| (window.location.pathname + window.location.hash);
	});
}
